import html2canvas from "html2canvas";

export const SHARE_ACTIONS = {
  COPY: "copy",
  DOWNLOAD: "download",
  EMAIL: "email",
  SHARE_X: "share_x",
  SHARE_TELEGRAM: "share_telegram",
  SHARE_FACEBOOK: "share_facebook",
  SHARE_LINKEDIN: "share_linkedin",
  MORE: "more",
};

export const MOBILE_SHARE_ACTIONS = [
  SHARE_ACTIONS.COPY,
  SHARE_ACTIONS.DOWNLOAD,
  SHARE_ACTIONS.EMAIL,
  SHARE_ACTIONS.MORE,
];

const captureCardCanvas = async (cardElement) => {
  if (!cardElement) return null;

  return html2canvas(cardElement, {
    backgroundColor: null,
    useCORS: true,
    scale: Math.min(window.devicePixelRatio || 1, 2),
  });
};

const canvasToBlob = (canvas) =>
  new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), "image/png");
  });

const buildFallbackText = ({ order, pnl }) => {
  const symbol = order?.symbol ? `${order.symbol} ` : "";
  const side = order?.side ? `${order.side} ` : "";
  const leverage = order?.leverage ? `| ${order.leverage}x ` : "";
  const pnlText = pnl != null ? `${pnl} USDT` : "--";
  return `${symbol}${side}${leverage}PnL: ${pnlText}`.trim();
};

const copyTextFallback = async (text) => {
  if (!navigator?.clipboard?.writeText) return false;
  await navigator.clipboard.writeText(text);
  return true;
};

const handleCopyImage = async ({ cardElement, order, pnl }) => {
  const canvas = await captureCardCanvas(cardElement);
  if (!canvas) return;
  const blob = await canvasToBlob(canvas);
  if (!blob) return;

  if (window.ClipboardItem && navigator?.clipboard?.write) {
    const item = new ClipboardItem({ "image/png": blob });
    await navigator.clipboard.write([item]);
    return;
  }

  await copyTextFallback(buildFallbackText({ order, pnl }));
};

const handleDownloadImage = async ({ cardElement }) => {
  const canvas = await captureCardCanvas(cardElement);
  if (!canvas) return;
  const blob = await canvasToBlob(canvas);
  if (!blob) return;

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `futures-share-${Date.now()}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const executeShareAction = async ({
  action,
  cardElement,
  order,
  pnl,
}) => {
  switch (action) {
    case SHARE_ACTIONS.COPY:
      await handleCopyImage({ cardElement, order, pnl });
      break;
    case SHARE_ACTIONS.DOWNLOAD:
      await handleDownloadImage({ cardElement });
      break;
    default:
      break;
  }
};
